import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-change-document-type',
  templateUrl: './change-document-type.component.html',
  styleUrls: ['./change-document-type.component.css']
})
export class ChangeDocumentTypeComponent implements OnInit {

  docTypeList: any = [];
  docTypeListTo: any = [];
  subDocTypeListTo: any = [];
  strURN: string = '';
  strProcessName: string = '';
  strComments: string = '';
  selectedDocumentType: any;
  selectedDocumentTypeTo: any;
  selectedSubDocumentTypeTo: any;
  lstURNData: any = [];
  chnageTypeColumnsToHide: any = ['DOCUMENT_DETAIL_ID'];
  selectedRecords: any = [];
  restrictedKeywords: any = [];
  isCommentExpand: boolean = false;
  isSubDocumentExists: boolean = false;
  modalReference: any;
  isDataFound: boolean = false;
  isApproved: boolean = false;
  // WorkITem Creation Range
  isWorkItemDateRangeHasValue = false;
  maxDate = new Date();
  workItemCreationDateRange = new FormGroup({
    work_item_start_date: new FormControl(),
    work_item_end_date: new FormControl(),
  });
  wordsTotal: any = 1000;

  // Invoice Creation Range
  isDateRangeHasValue = false;
  //maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });
  strRange: string = '1-9999999';

  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService

  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getDocumentTypes();

  }

  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }
  getDocumentTypes() {
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
     params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            this.docTypeList = [];
            res.data.forEach((element) => {
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name
              });
            });

            this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
            this.onSelectDocumentType(this.selectedDocumentType);
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  onSelectDocumentType(docId) {

    this.docTypeListTo = Object.assign([], this.docTypeList);
    let index = this.docTypeList.findIndex(x => x.value === docId);
    this.docTypeListTo.splice(index, 1)
    this.selectedDocumentTypeTo = this.docTypeListTo.length > 0 ? this.docTypeListTo[0].value : '';
    if (this.docTypeListTo.length > 0) {
      this.onSelectDocumentTypeTo(this.selectedDocumentTypeTo)
    }
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;

  }

  onSelectDocumentTypeTo(docId) {

    let obj = {
      action: "SUB_DOC_WITH_PROCESS",
      projectId: this.commonService.selectedProject,
      documentTypeId: this.selectedDocumentTypeTo,
      urn: "",
      durationCreateDate: "",
      durationInvoiceDate: ""

    }

    this.subDocTypeListTo = [];
    this.isSubDocumentExists = false;
    this.strProcessName = "";
    this.dataService.getData('getWorkItemTypeChangeFilter', obj).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.Table.forEach((element) => {
              this.subDocTypeListTo.push({
                value: element.value,
                text: element.text
              });
            });
            this.isSubDocumentExists = this.subDocTypeListTo.length > 0 ? true : false;
            res.data.Table1.forEach((element) => {
              this.strProcessName = element.text;
            });

          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getOpenSearchData() {


    let invalidSubmitMsg = '';

    let objDocType = this.docTypeList.find(el => el.value == this.selectedDocumentType);

    invalidSubmitMsg += typeof objDocType !== "undefined" && objDocType.value != 0 ? '' : '-Please select work item type.\r <br/>';
    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
      return;
    }
    else {
      if (this.commonService.dateFormating(this.invoiceCreationDateRange.value.start_date) != null && this.commonService.dateFormating(this.invoiceCreationDateRange.value.end_date) == null) {
        this.commonService.showMessageBox('Please select invoice creation end date', 'Alert');
        return;
      }
      if (this.commonService.dateFormating(this.workItemCreationDateRange.value.work_item_start_date) != null && this.commonService.dateFormating(this.workItemCreationDateRange.value.work_item_end_date) == null) {
        this.commonService.showMessageBox('Please select work item creation end date', 'Alert');
        return;
      }
      let indexRange: any;
      indexRange = this.strRange.split('-');
      if (indexRange.length != 2) {
        this.commonService.showMessageBox("Please enter valid range like (1-9999999)", 'Alert');
        return;
      }

      if (isNaN(indexRange[0]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range", 'Alert');
        return;
      }

      if (isNaN(indexRange[1]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }
      if (indexRange[0] == 0 || indexRange[1] == 0) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }

      if (indexRange[0] > indexRange[1]) {
        this.commonService.showMessageBox("Please enter valid range.", 'Alert');
        return;
      }
      let invoice_dateRange: any = { start_date: '', end_date: '' };
      let invoice_dt: string = "";

      if (this.isDateRangeHasValue) {
        invoice_dateRange = {
          start_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.start_date
          ),
          end_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.end_date
          ),
        };
        invoice_dt = invoice_dateRange.start_date + '/' + invoice_dateRange.end_date;
      }
      let create_dateRange: any = { start_date: '', end_date: '' };

      let create_dt: string = "";
      if (this.isWorkItemDateRangeHasValue) {
        create_dateRange = {
          start_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_start_date
          ),
          end_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_end_date
          ),
        };
        create_dt = create_dateRange.start_date + '/' + create_dateRange.end_date;
      }
      let obj = {
        action: "FILTER",
        projectId: this.commonService.selectedProject,
        documentTypeId: this.selectedDocumentType,
        urn: this.strURN,
        durationCreateDate: create_dt,
        durationInvoiceDate: invoice_dt,
        from_range: Number(indexRange[0]),
        to_range: Number(indexRange[1]),

      }


      if (this.lstURNData.length > 0) {
        this.lstURNData.splice(0, this.lstURNData.length)
      }


      this.dataService.getData('getWorkItemTypeChangeFilter', obj).subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.lstURNData = res.data.Table;
              this.isDataFound = true;
              if (res.data.Table.length <= 0) {
                this.commonService.showMessageBox('No Data Found', 'Alert');
                this.isDataFound = false;
              }
            }
            else {
              this.isDataFound = false;
              this.commonService.showMessageBox('No Data Found', 'Alert');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
    }

  }
  ClearOpenSearch() {
    this.strRange = '1-9999999';
    this.strURN = '';
    this.resetInvoiceCreationDateRange();
    this.resetWorkItemCreationDateRange();
    this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  onWorkItemCreationDateChanges() {
    if (
      this.workItemCreationDateRange.value.work_item_start_date != '' ||
      this.workItemCreationDateRange.value.work_item_end_date != ''
    ) {
      this.isWorkItemDateRangeHasValue = true;
    }
  }

  resetWorkItemCreationDateRange() {
    this.workItemCreationDateRange = new FormGroup({
      work_item_start_date: new FormControl(),
      work_item_end_date: new FormControl(),
    });
    this.isWorkItemDateRangeHasValue = false;
  }

  cellClickEvent(event: any) {
    // if (event.columnName == 'action_checkbox_button' && event.rowData.action_checkbox_button.toString() == 'false') {
    //   this.selectedRecords.push(event.rowData.DOCUMENT_DETAIL_ID);
    // }
    // else if (event.columnName == 'action_checkbox_button' && event.rowData.action_checkbox_button.toString() == 'true') {
    //   let index = this.lstURNData.findIndex(x => x.DOCUMENT_DETAIL_ID === event.rowData.DOCUMENT_DETAIL_ID);
    //   this.selectedRecords.splice(index, 1)
    // }
  }

  checkRestrictedKeywords(formControlName: string) {
    let foundedRestrictedKeyword = [];
    var input = this.strComments;
    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = this.replaceAll(input, keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.strComments = input;
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }

  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }
  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  sumbitData() {

    let invalidSubmitMsg = '';
    let subDocumentId: number = 0;
    if (this.isSubDocumentExists == true) {

      let objSubDoc: any;
      if (typeof this.selectedSubDocumentTypeTo !== "undefined") {
        objSubDoc = this.subDocTypeListTo.find(el => el.value == this.selectedSubDocumentTypeTo).value;
        invalidSubmitMsg += typeof objSubDoc !== "undefined" && objSubDoc > 0 ? '' : '-Please select category.\r <br/>';
        subDocumentId = objSubDoc;

      }
      else {
        invalidSubmitMsg += '-Please select category.\r <br/>';
      }
    }

    let objDocTypeTo = this.docTypeListTo.find(el => el.value == this.selectedDocumentTypeTo);
    invalidSubmitMsg += typeof this.strComments !== "undefined" && this.strComments != '' ? '' : '-Please enter comment.\r <br/>';

    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');

    }
    else {

      let dataList: any = [];
      this.lstURNData.forEach((element) => {
        if (element.action_checkbox_button == true) {
          let obj = {
            DocumentDetailId: element.DOCUMENT_DETAIL_ID,
            SrcDocumentTypeId: this.selectedDocumentType,
            DestDocumentTypeId: this.selectedDocumentTypeTo,
            DestSubDocTypeId: subDocumentId,
            Reason: this.strComments,
            // // UserId: this.commonService.getUserInfoFromLocalStorage('userId')
            // UserId: this.memorystore.getItem('userId')
            UserId: this.memorystore.getItem('userId')

          }
          dataList.push(obj);
        }

      });

      if (dataList.length <= 0) {
        this.commonService.showMessageBox('Please select at least one URN to change the work item.', 'Alert');
      }
      else {

        if (this.isApproved == false) {
          this.showModal(this.invoiceSubmittedModal, 'lg');
        }
        else {

          this.isApproved = false;

          let initial_params = {
            lstParameter: dataList
          }
          this.dataService.postData('postWorkItemChange', initial_params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.status != null) {
                this.commonService.showMessageBox('Document Type changed to ' + objDocTypeTo.text + ' for ' + dataList.length + ' URN(s). These have been moved to ' + this.strProcessName + '.', 'Alert');
                this.isDataFound = false;
                this.strComments = "";
                if (this.lstURNData.length > 0) {
                  this.lstURNData.splice(0, this.lstURNData.length)
                }

              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.route.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
            error => {
              if (error.includes("401")) {
                this.route.navigateByUrl('/unauthorized');
                return;
              }
            });
        }
      }


    }
  }

  processInvoice() {
    this.isApproved = true;
    this.sumbitData();
  }

}
